import { render, staticRenderFns } from "./IsHealthyIcon.vue?vue&type=template&id=27b84120&lang=pug&"
import script from "./IsHealthyIcon.vue?vue&type=script&lang=ts&"
export * from "./IsHealthyIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports